import { TableBadgeLabel } from '@components'

import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { invoiceStatusToBadgeColor } from '@features/invoicesLegacy/constants/invoiceStatusToBadgeVariant'
import { InvoiceStatus } from '@features/invoicesLegacy/enums/invoiceStatus'

import { useInvoicesListFilters } from '../../hooks/useInvoicesListFilters'
import { useInvoiceSummaryFiltered } from '../../hooks/useInvoicesSummaryFiltered'
import { getBadgeAmountForStatusAll } from '../../utils/getBadgeAmountForStatus'
import { getInvoicesTitle } from '../../utils/getInvoicesTitle'

export const InvoicesTitle = (): ReactElement => {
  const { t } = useTranslation()
  const { isLoading, data } = useInvoiceSummaryFiltered()
  const [filters] = useInvoicesListFilters()

  const status = filters?.status || InvoiceStatus.All
  const totalAmount =
    status === InvoiceStatus.All && data ? getBadgeAmountForStatusAll(data) : data?.[status]?.count || 0
  const title = getInvoicesTitle(status, totalAmount, t)
  const variant = invoiceStatusToBadgeColor[status]

  return (
    <TableBadgeLabel amount={totalAmount} isLoading={isLoading} color={variant}>
      {title}
    </TableBadgeLabel>
  )
}
